import script from "./WatchlistSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchlistSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./WatchlistSidebar.vue?vue&type=style&index=0&id=04ee9f06&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ee9f06"]])

export default __exports__